import * as TYPES from './types.js';
export default {
    //  set up  listingStatus  the value of 
    [TYPES.SET_LISTING_STATUS](state, payload = {}) {
        state.listingStatus = [...payload.data];
    },
    //  set up  listing  the value of 
    [TYPES.SET_LISTING](state, payload = {}) {
        state.listing = [...payload.data];
    },

    //  set up  currentListingStatus  the value of 
    [TYPES.SET_CURRENT_LISTING_STATUS](state, payload = {}) {
        state.currentListingStatus = payload.data;
    },
    //  set up  currentListingStatus  the value of 
    [TYPES.SET_FETCH_LISTING_STATUS](state, payload = {}) {
        state.fetchListingStatus = payload.data;
    },
    [TYPES.SET_CURRENT_LISTING_NAME](state, payload = {}) {
        state.currentListingStatusName = payload.data;
    },
    [TYPES.SET_SEARCH_PARAMS](state, payload = {}) {
        state.searchParams = { ...payload };
    },
    //  Set the total number of pages for pagination 
    [TYPES.SET_TOTAL_PAGE](state, payload = {}) {
        state.totalPage = payload.data;
    },
    //  set current page 
    [TYPES.SET_PAGE_NUM](state, payload = {}) {
        state.pageNum = payload.data;
    },
    //  whether to display sold listing price
    // [TYPES.SET_SHOW_SOLD_LISTING_PRICE](state, payload = {}) {
    //     state.showSoldPrice = payload.data;
    // },
    //  whether to display listing price
    [TYPES.SET_SHOW_LISTING_PRICE](state, payload = {}) {
        state.showListingPrice = payload.data;
    },
    [TYPES.SET_HAS_LOCATION](state, payload = {}) {
        state.hasLocation = payload.data;
    },
    //  Sold listing information 
    [TYPES.SET_SOLD_LISTING_INFO](state, payload = {}) {
        state.soldListingInfo = payload.data;
    }
};
